<!--
 * @Author: your name
 * @Date: 2020-07-29 11:51:28
 * @LastEditTime: 2020-08-08 14:50:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/lib/ui/components/form/form-document-number/form-document-number.vue
--> 
<template>
  <div class="form-document-number form-item">
    <x-proxy-form-item
    :showRequired="showRequired"
    :label="widget.label"
    :processTitle="widget.processTitle"
    :validatorRules="validatorRules"
    :validateKey="validateKey"
    :validateInfo="validateInfo"
    :disabled="true">
      <cube-input
        v-if="renderSence === 'edit'"
        v-model="formValue"
        :disabled="true"
        :placeholder="'提交后自动生成'"
        :maxlength="widget.lengthLimit"
        :readonly="true"
        :tabindex="tabindex"
      ></cube-input>
      <input v-else-if="renderSence === 'read'" class="cube-input-field text-overflow" readonly :value="formValue || '-'" />
    </x-proxy-form-item>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'

export default {
  name: 'FormDocumentNumber',
  mixins: [FormWidgetConfigMixin],
  watch: {
    'widget.documentNumRules': {
      handler: function(newVal, oldVal) {
        if (newVal && newVal.length > 0) {
          const now = new Date()
          let str = ''
          newVal.forEach((item) => {
            if (item.ruleType === 'CURRENT_YEAR') {
              str += `${now.getFullYear()}`
            } else if (item.ruleType === 'CURRENT_MONTH') {
              const temp = `${now.getMonth() + 1}`
              str += temp.length === 1 ? `0${temp}` : temp
            } else if (item.ruleType === 'CURRENT_DAY') {
              const temp = `${now.getDate()}`
              str += temp.length === 1 ? `0${temp}` : temp
            } else if (item.ruleType === 'WATER_CODE') {
              let temp = ''
              for (let i = 0; i < item.placeSpace; i++) {
                if (i + 1 === item.placeSpace) {
                  temp += '1'
                } else {
                  temp += '0'
                }
              }
              str += `${temp}`
            } else if (item.ruleType === 'STATIC_TEXT') {
              str += `${item.staticText}`
            } else if (item.ruleType === 'FORM_FIELD') {
              str += `${
                this.getComponentConfigByUuid(this.formConfigList, item.formField).componentConfig
                  .label
              }`
            }
          })
          this.widget.placeholder = str
        } else {
          this.widget.placeholder = '请选择单据号规则'
        }
      },
      immediate: true
    }
  },
  methods: {
    getComponentConfigByUuid(formItemList, uuid) {
      let result
      for (const item of formItemList) {
        if (item.componentConfig.uuid === uuid) {
          result = item
          break
        } else if (item.componentConfig.children) {
          result = this.getComponentConfigByUuid(item.componentConfig.children, uuid)
        }
      }
      return result
    }
  }
}
</script>

<style>

</style>